module.exports = __webpack_public_path__ + "img/m_home_news_head.385a1332.png";